import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import {
  MissingInformationOverride,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/missingInformation/metaOverrideSet';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { FDBox } from '@facet-wealth/design';
import OnboardingPlannerViewSectionHeader
  from '../../Components/OnboardingPlannerViewSectionHeader';
import { MissingInformationSection } from './section';

const useStyles = buildUseStyles('MissingInformationLayout', (theme) => ({
  sections: {
    '& > * + *': {
      ...getBorder(theme, { top: true }),
    },
  },
}));

export function MissingInformationLayout() {
  const {
    resource,
  } = useMetaLayoutContext();
  const sections = resource.attr('sectionData')?.resources().list();
  const classes = useStyles();

  return (
    <>
      <FDBox paddingX={3}>
        <OnboardingPlannerViewSectionHeader
          title={resource.attr('title')}
          additionalActions={<SecondaryActionButtonRel relationship={resource.relationship(fr.relationships.guidedHouseholdReview.name)} size="lg" />}
        />
      </FDBox>
      <div className={classes.sections}>
        {sections.map((section) => (
          <MetaResourceRenderer
            key={section.id()}
            resource={section}
            layout={MissingInformationSection}
            metaOverrideSet={MissingInformationOverride}
          />
        ))}
      </div>
    </>
  );
}
